import React from 'react';
import Icon from '../../../components/AppIcon';

const AdminMetricCard = ({ title, value, icon, trend, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-green-500/10 text-green-600',
    warning: 'bg-yellow-500/10 text-yellow-600',
    info: 'bg-blue-500/10 text-blue-600',
    error: 'bg-red-500/10 text-red-600'
  };

  return (
    <div className="card p-6 hover:shadow-lg transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className={`p-3 rounded-xl ${colorClasses?.[color]}`}>
          <Icon name={icon} size={24} />
        </div>
      </div>
      <h3 className="text-sm font-medium text-muted-foreground mb-1">{title}</h3>
      <p className="text-3xl font-bold text-foreground mb-2">{value}</p>
      {trend && (
        <p className="text-sm text-muted-foreground">{trend}</p>
      )}
    </div>
  );
};

export default AdminMetricCard;